import { createFileRoute } from "@tanstack/react-router";
import AdminRecoPage from "@/admin/pages/reco";

export const Route = createFileRoute("/admin/reco")({
  component: AdminRecoPage,
});
